export const incorrectDocumentHeightHandler = {
    register: () => {},
};
